export default __webpack_public_path__ + "static/media/value_05.e035559d.png";